<template>
	<div>
		<div class="bigBox">
			<div class="leftCont">
				<div class="banner4">
					<div class="mendio">
						<div class="name1">让每个商家，</div>
						<div class="name2">拥有最适合自己的产品</div>
						<el-button type="text" class="Ufree" @click="goCont"><span 
							style="color: #fff !important;margin-left: unset !important;">预约咨询</span></el-button>
						<!--
						<el-button type="text" class="Ufree" @click="dvSaas = true"><span style="color: #fff !important;margin-left: unset !important;">立即体验(外卖)</span></el-button>
						<el-button type="text" class="Ufree" @click="dvQuan = true"><span style="color: #fff !important;margin-left: unset !important;">立即体验(MOMI互推)</span></el-button>
						<el-button type="text" class="Ufree" @click="dvStore = true"><span style="color: #fff !important;margin-left: unset !important;">立即体验(商城)</span></el-button>-->
						<div class="Comuni">咨询电话：159 8989 7729</div>
					</div>
				</div>
				<div class="priceBox">
					<div class="title cis">MOMI外卖</div>
					<div class="fstPrice">
						<div class="fsttitle">合作版</div>
						<div class="sub-title">适合直营店/单店</div>
						<div class="desc">无论刚起步，还是有稳定的客源的餐饮店，都可以使用此版本</div>
						<p class="price">
							¥ 1680
							<span>/年</span>
						</p>
					</div>
					<div class="secPice">
						<div class="fsttitle">专业版</div>
						<div class="sub-title">适合品牌店/旗舰店</div>
						<div class="desc">打造自己的私域流量，提升品牌知名度</div>
						<p class="price">
							¥ 5680
							<span>/年</span>
						</p>
					</div>
					<div class="thrPrice">
						<div class="fsttitle">定制版</div>
						<div class="sub-title">适合品牌店/连锁店</div>
						<div class="desc">有个性化需求，为品牌店、连锁店做专门定制</div>
						<p class="price">
							¥ 98000
							<span>/起</span>
						</p>
					</div>
				</div>
				<div class="priceBox">
					<div class="title cis">MOMI互推</div>
					<div class="fstPrice">
						<div class="fsttitle">基础版</div>
						<div class="sub-title">适合直营店/单店</div>
						<div class="desc">有大量客户，需要增加变现渠道；或者有好产品、好项目，需要客户；想做条轻松的“咸鱼”</div>
						<p class="price">
							¥ 2900
							<span>/年</span>
						</p>
					</div>
					<div class="secPice">
						<div class="fsttitle">专业版</div>
						<div class="sub-title">适合品牌店/连锁店</div>
						<div class="desc">连锁店或有一定实力的品牌店，有较多商业资源，可组建自己的异业联盟</div>
						<p class="price">
							¥ 21800
							<span>/年</span>
						</p>
					</div>
					<div class="thrPrice">
						<div class="fsttitle">定制版</div>
						<div class="sub-title">适合品牌店/连锁店</div>
						<div class="desc">有个性化需求，连锁店或有实力的品牌店，有较多商业资源，组建自己的异业联盟</div>
						<p class="price">
							¥ 128000
							<span>/起</span>
						</p>
					</div>
				</div>
				<div class="priceBox">
					<div class="title cis">MOMI商城</div>
					<div class="fstPrice">
						<div class="fsttitle">基础版</div>
						<div class="sub-title">适合直营店/单店/创业者</div>
						<div class="desc">线上线下结合的门店；微商或者单纯的想多个线上渠道；或者有好的货源；请选择</div>
						<p class="price">
							¥ 1800
							<span>/年</span>
						</p>
					</div>
					<div class="secPice">
						<div class="fsttitle">专业版</div>
						<div class="sub-title">适合品牌店/厂家/供应商</div>
						<div class="desc">打造品牌的商家；生产产品的厂家；提供好产品的供应商、批发商；</div>
						<p class="price">
							¥ 12800
							<span>/年</span>
						</p>
					</div>
					<div class="thrPrice">
						<div class="fsttitle">定制版</div>
						<div class="sub-title">适合品牌店/厂家/供应商</div>
						<div class="desc">有个性化需求的品牌商家；生产产品的厂家；提供好产品的供应商、批发商</div>
						<p class="price">
							¥ 58000
							<span>/起</span>
						</p>
					</div>
				</div>
				<div class="emtyBox"></div>
			</div>
			<right-cont :activeIndex="activeIndex"></right-cont>
			<!-- <right-cont :dialogVisible="dvSaas"></right-cont>
			<right-cont :dialogVisible="dvQuan"></right-cont>
			<right-cont :dialogVisible="dvStore"></right-cont> -->
			<el-dialog title="" :visible.sync="dvSaas" width="30%" :before-close="handleClose">
				<div>
					<img class="pop-pic" src="../assets/images/saas_try.jpg" />
					<div class="free-use">扫码立即体验</div>
				</div>
			</el-dialog>
			<el-dialog title="" :visible.sync="dvQuan" width="30%" :before-close="handleClose">
				<div>
					<img class="pop-pic" src="../assets/images/qr_tool.jpg" />
					<div class="free-use">扫码立即体验</div>
				</div>
			</el-dialog>
			<el-dialog title="" :visible.sync="dvStore" width="30%" :before-close="handleClose">
				<div>
					<img class="pop-pic" src="../assets/images/store_try.jpg" />
					<div class="free-use">扫码立即体验</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import msgFoot from '../components/msgFoot.vue'
	import rightCont from '../components/rightCont.vue'
	export default {
		components: {
			msgFoot,
			rightCont
		},
		data() {
			return {
				activeIndex: '4',
				dialogVisible: false,
				dvSaas: false,
				dvQuan: false,
				dvStore: false
			}
		},
		methods: {
			goCont()
			{  
				console.log('xxxxzz', this.$children) 
				rightCont.openMe(this.$children[1]);
			},
			handleClose(done) {
				done();
			}
		},
		mounted() {
			window.scroll(0, 0);
		}
	}
</script>

<style>
	@media screen and (max-width: 600px) {
		.price {
			font-weight: 500;
			font-size: 6.4vw;
			color: #ff6a00;
			line-height: 12.8vw;
		}

		.priceBox {
			text-align: center;
			overflow: hidden;
			padding: 5vw;
			margin-left: 0;
			overflow: hidden;
		}

		.grid-add {
			background-color: #f7f8fa;
			overflow: hidden;
			color: #666;
			text-align: center;
			padding: 0 5vw;
		}

		.name1 {
			font-size: 3.4vw;
			color: #fff;
			padding-top: 10vw;
			text-align: center;
		}

		.name2 {
			font-size: 3.4vw;
			color: #fff;
			margin-top: 2vw;
			text-align: center;
		}

		.fstPrice {
			padding: 10vw;
			-webkit-box-shadow: 0 0 2vw 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 2vw 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin: 0 auto;
			margin-top: 2vw;
		}

		.secPice {
			padding: 10vw;
			-webkit-box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin: 0 auto;
			margin-top: 4vw;
		}

		.thrPrice {
			padding: 10vw;
			-webkit-box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin: 0 auto;
			margin-top: 4vw;
		}

		.forms {
			width: 100%;
			/* margin: 65px auto 56px; */
			border: 1px solid #e5e5e5;
		}

		.comCont1 {
			flex: 1;

		}

		.exlBox {
			margin-left: 3vw;
			margin-right: 3vw;
			border-top: 1px #ddd solid;
			border-left: 1px #ddd solid;
			line-height: 8vw;
			font-size: 3.6vw;
			margin-top: 4vw;
		}

		.exlbox-cont {
			flex: 1;
			border-right: 1px #ddd solid;
		}

		.exlbox1 {
			border-bottom: 1px #ddd solid;
			flex: 1;
			display: flex;

		}

		.ftitle {
			display: flex;
			background-color: #f9f9f9;
		}

		.add-title {
			margin-top: 2.4vw;
			margin-bottom: 1.2vw;
			font-size: 1.8vw;
			color: #333;
			line-height: 1.8vw;
		}

		.price-detail {
			font-size: 1.3vw;
			line-height: 5.6vw;
			margin-bottom: 2.4vw;
			color: #666;
		}

		.fsttitle {
			font-size: 3.6vw;
			color: #333;
			line-height: 3.6vw;
			font-weight: 600;
		}

		.sub-title {
			font-size: 2.8vw;
			color: #666;
			text-align: center;
			line-height: 4vw;
			height: 4vw;
			margin-top: 1.6vw;
			margin-bottom: 1.6vw;
		}

		.desc {
			font-size: 2.4vw;
			color: #666;
			text-align: center;
			line-height: 4vw;
			margin-bottom: 1.6vw;
			height: 16vw;
		}

		span {
			margin-left: 1vw;
			font-size: 1.4vw;
			font-weight: 300;
			color: #999;
		}

		.tsb {
			color: #ff6a00;
		}
	}

	@media screen and (min-width: 600px) and (max-width: 1200px) {
		.price {
			font-weight: 500;
			font-size: 6.4vw;
			color: #ff6a00;
			line-height: 12.8vw;
		}

		.priceBox {
			text-align: center;
			overflow: hidden;
			padding: 5vw;
			margin-left: 0;
			overflow: hidden;
		}

		.grid-add {
			background-color: #f7f8fa;
			overflow: hidden;
			color: #666;
			text-align: center;
			padding: 0 5vw;
		}

		.name1 {
			font-size: 5.4vw;
			color: #fff;
			padding-top: 9vw;
			text-align: center;
		}

		.name2 {
			font-size: 5.4vw;
			color: #fff;
			margin-top: 2vw;
			text-align: center;
		}

		.fstPrice {
			padding: 10vw;
			-webkit-box-shadow: 0 0 2vw 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 2vw 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin: 0 auto;
			margin-top: 2vw;
		}

		.secPice {
			padding: 10vw;
			-webkit-box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin: 0 auto;
			margin-top: 4vw;
		}

		.thrPrice {
			padding: 10vw;
			-webkit-box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 4vw 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin: 0 auto;
			margin-top: 4vw;
		}

		.forms {
			width: 100%;
			/* margin: 65px auto 56px; */
			border: 1px solid #e5e5e5;
		}

		.comCont1 {
			flex: 1;

		}

		.exlBox {
			margin-left: 3vw;
			margin-right: 3vw;
			border-top: 1px #ddd solid;
			border-left: 1px #ddd solid;
			line-height: 8vw;
			font-size: 3.6vw;
			margin-top: 4vw;
		}

		.exlbox-cont {
			flex: 1;
			border-right: 1px #ddd solid;
		}

		.exlbox1 {
			border-bottom: 1px #ddd solid;
			flex: 1;
			display: flex;

		}

		.ftitle {
			display: flex;
			background-color: #f9f9f9;
		}

		.add-title {
			margin-top: 2.4vw;
			margin-bottom: 1.2vw;
			font-size: 1.8vw;
			color: #333;
			line-height: 1.8vw;
		}

		.price-detail {
			font-size: 1.3vw;
			line-height: 5.6vw;
			margin-bottom: 2.4vw;
			color: #666;
		}

		.fsttitle {
			font-size: 3.6vw;
			color: #333;
			line-height: 3.6vw;
			font-weight: 600;
		}

		.sub-title {
			font-size: 2.8vw;
			color: #666;
			text-align: center;
			line-height: 4vw;
			height: 4vw;
			margin-top: 1.6vw;
			margin-bottom: 1.6vw;
		}

		.desc {
			font-size: 2.4vw;
			color: #666;
			text-align: center;
			line-height: 4vw;
			margin-bottom: 1.6vw;
			height: 16vw;
		}

		span {
			margin-left: 1vw;
			font-size: 1.4vw;
			font-weight: 300;
			color: #999;
		}

		.tsb {
			color: #ff6a00;
		}
	}

	@media screen and (min-width: 1200px) {
		.sec-emtybox {
			width: 125px;
			float: left;
			height: 50px;
			margin-left: 20px;
		}

		.comCont1 {
			flex: 1;
			width: 191px;
			height: 40px;
			line-height: 40px;
			text-align: left;
			padding-left: 14px;
		}

		.emtyBox {
			height: 50px;
			width: 100%;
		}

		.forms {
			width: 790px;
			margin: 65px auto 56px;
			border: 1px solid #e5e5e5;
		}

		.try {
			width: 170px;
			height: 40px;
			text-align: center;
			display: block;
			margin: 32px 0 15px;
			line-height: 40px;
			border-radius: 3px;
			background-color: #fff;
			color: #8558fa;
		}

		.priceBox {
			text-align: center;
			overflow: hidden;
			padding-bottom: 20px;
			margin-left: 0;
			/* width: 872px; */
			overflow: hidden;
		}

		.grid-add {
			width: 790px;
			margin: 0 auto;
			background-color: #f7f8fa;
			overflow: hidden;
			color: #666;
			text-align: center;
		}

		.name1 {
			font-size: 34px;
			color: #fff;
			line-height: 44px;
			padding-top: 67px;
		}

		.name2 {
			font-size: 34px;
			color: #fff;
			line-height: 44px;
		}

		.fstPrice {
			float: left;
			width: 300px;
			padding: 25px;
			-webkit-box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin-left: 50px;
		}

		.secPice {
			float: left;
			width: 300px;
			padding: 25px;
			-webkit-box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin-left: 25px;
		}

		.thrPrice {
			float: left;
			width: 300px;
			padding: 25px;
			-webkit-box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
			box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
			background-color: #fff;
			margin-left: 25px;
		}

		.exlBox {
			margin-left: 40px;
			margin-right: 40px;
			border-top: 1px #ddd solid;
			border-left: 1px #ddd solid;
			line-height: 40px;
			font-size: 18px;
			margin-top: 40px;
		}

		.exlbox-cont {
			flex: 1;
			border-right: 1px #ddd solid;
		}

		.exlbox1 {
			border-bottom: 1px #ddd solid;
			flex: 1;
			display: flex;

		}

		.tsb {
			color: #ff6a00;
		}

		.iconPic {
			width: 20px;
			height: 20px;
			margin-top: 10px;
		}

		.cis {
			margin-bottom: 50px;
		}

		.ftitle {
			display: flex;
			background-color: #f9f9f9;
		}

		.comCont {
			display: flex;
			border-top: 1px #e5e5e5 solid;
			align-items: center;
		}

		.comCont2 {
			flex: 1;
			width: 191px;
			height: 40px;
			text-align: center;
			border-left: 1px solid #e5e5e5;
		}

		.comCont3 {
			flex: 1;
			width: 191px;
			height: 40px;
			text-align: center;
			border-left: 1px solid #e5e5e5;
		}

		.comCont4 {
			flex: 1;
			width: 191px;
			height: 40px;
			text-align: center;
			border-left: 1px solid #e5e5e5;
		}

		.compare {
			font-size: 12px;
			line-height: 32px;
			padding-left: 14px;
			text-align: left;
			height: 32px;
			color: #333;
			background-color: #f9f9f9;
			border-top: 1px solid #e5e5e5;
		}

		.title-text1 {
			flex: 1;
			width: 191px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			font-weight: 800;
			padding-left: 14px;
		}

		.title-text2 {
			flex: 1;
			width: 191px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			border-left: 1px solid #e5e5e5;
			font-weight: 800;
		}

		.title-text3 {
			flex: 1;
			width: 191px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			border-left: 1px solid #e5e5e5;
			font-weight: 800;
		}

		.title-text4 {
			flex: 1;
			width: 191px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			border-left: 1px solid #e5e5e5;
			font-weight: 800;
		}

		.add-title {
			margin-top: 24px;
			margin-bottom: 12px;
			font-size: 18px;
			color: #333;
			line-height: 18px;
		}

		.price-detail {
			font-size: 13px;
			line-height: 26px;
			margin-bottom: 24px;
			color: #666;
		}

		.fsttitle {
			font-size: 18px;
			color: #333;
			line-height: 18px;
			font-weight: 800;
		}

		.sub-title {
			font-size: 14px;
			color: #666;
			text-align: center;
			line-height: 20px;
			height: 40px;
			margin-top: 16px;
			margin-bottom: 16px;
		}

		.desc {
			font-size: 14px;
			color: #666;
			text-align: center;
			line-height: 20px;
			margin-bottom: 16px;
			height: 80px;
		}

		.price {
			font-weight: 500;
			font-size: 32px;
			color: #ff6a00;
			line-height: 32px;
		}

		span {
			margin-left: 10px;
			font-size: 14px;
			font-weight: 300;
			color: #999;
		}
	}
</style>
